/**
 * @desc 通过Redis更新用户编号
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.updateApproverUserNo.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/updateApproverUserNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
